export default __webpack_public_path__ + "static/media/score.1d3aedf7.svg";